// extracted by css-extract-rspack-plugin
export default {"button":"ImB5nGxHoR8jIUUQ"};